var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#F7F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 24.3973C26 23.0733 27.0968 22 28.4498 22C37.4833 22 46.5167 22.0001 55.5502 22C56.9032 22 58 23.0733 58 24.3974V61.6027C58 62.9267 56.9032 64 55.5502 64C46.5167 64 37.4833 64 28.4498 64C27.0968 64 26 62.9267 26 61.6027V24.3973Z",
    fill: "#8E8CEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 20.3973C22 19.0733 23.0968 18 24.4498 18C33.4833 18 42.5167 18.0001 51.5502 18C52.9032 18 54 19.0733 54 20.3974V57.6027C54 58.9267 52.9032 60 51.5502 60C42.5167 60 33.4833 60 24.4498 60C23.0968 60 22 58.9267 22 57.6027V20.3973Z",
    fill: "#E6E5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 23C26 22.4477 26.4477 22 27 22H45C45.5523 22 46 22.4477 46 23C46 23.5523 45.5523 24 45 24H27C26.4477 24 26 23.5523 26 23Z",
    fill: "#B1B0F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 55C30 54.4477 30.4477 54 31 54H49C49.5523 54 50 54.4477 50 55C50 55.5523 49.5523 56 49 56H31C30.4477 56 30 55.5523 30 55Z",
    fill: "#B1B0F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 27C26 26.4477 26.4477 26 27 26H37C37.5523 26 38 26.4477 38 27C38 27.5523 37.5523 28 37 28H27C26.4477 28 26 27.5523 26 27Z",
    fill: "#B1B0F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2829 34.6502L35.8729 42.0602L32.6843 38.8717C32.1005 38.2878 31.1125 38.2878 30.4838 38.8717C29.8999 39.4555 29.8999 40.4435 30.4838 41.0722L34.7502 45.3386C35.0645 45.653 35.4238 45.7877 35.828 45.7877C36.2322 45.7877 36.6364 45.653 36.9058 45.3386L45.4386 36.8058C46.0224 36.222 46.0224 35.234 45.4386 34.6053C44.8548 34.0214 43.8668 34.0214 43.2829 34.6502Z",
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckDoc);
export default __webpack_public_path__ + "static/media/CheckDoc.9f7bb399c827c5b7018a7fe22ee483a9.svg";
export { ForwardRef as ReactComponent };